import React from 'react';

const StylistTheme = {
  headerLogo: {
    src: '/themes/theme/stylist/stylist-dark.png',
    alt: 'Stylist influencers',
  },
  darkLogo: {
    src: '/themes/theme/stylist/stylist-dark-large.png',
    alt: 'Stylist influencers',
    size: 100,
  },
  headerStyle: {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #3dd2be',
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'STYLIST | CAMPAIGNS',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="70" src="/themes/theme/stylist/stylist-dark-large.png" alt="Stylist Influencers" />
      <br />
      <br />
      <p style={{ fontSize: 'large' }}>Automated Influencer Campaign Tracking</p>
      <hr />
      <p>
        Stylist is the online home of Stylist Magazine, featuring all of the latest lifestyle, fashion, beauty, travel, wellness & entertainment news, all through a feminist lens.
      </p>
    </div>
  ),
  shareSite: 'https://reports.stylist.co.uk',
  organisationId: '5bf5b36b-48cb-4d2a-a304-580db89965f9',
};

export default StylistTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/stylist.js
 **/